import TagManager from 'react-gtm-module'
import config from '../api/config'

export function isGtmEnabled() {
    const origin = window.location.origin
    return Boolean(config.gtmId) && !origin.includes('test') && !origin.includes('local')
}

export function sendGtmEvent(name, eventId, payload = {}) {
    if (!isGtmEnabled()) return false
    const key = `gtm-event:${eventId}`
    try {
        if (window.localStorage.getItem(key)) return true
    } catch (error) {
        // GTM can still receive the event when browser storage is unavailable.
    }

    TagManager.dataLayer({
        dataLayer: {
            path: window.location.pathname,
            transaction_id: null,
            value: null,
            currency: null,
            credits: null,
            plan_id: null,
            plan_name: null,
            plan_type: null,
            plan_interval: null,
            plan_interval_count: null,
            report_id: null,
            ...payload,
            event: name,
            event_id: eventId,
        },
    })
    try {
        window.localStorage.setItem(key, '1')
    } catch (error) {
        // The server acknowledgement remains the primary deduplication record.
    }
    return true
}
